/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  DOCUMENTS_FETCH_REQUEST,
  DOCUMENTS_FETCH_REQUEST_SUCCESS,
  DOCUMENTS_FETCH_REQUEST_FAILURE,
  DOCUMENT_CLEAN_REQUEST,
  DOCUMENT_ADD_REQUEST,
  DOCUMENT_ADD_REQUEST_SUCCESS,
  DOCUMENT_ADD_REQUEST_FAILURE,
  DOCUMENT_YEARS_FETCH_REQUEST,
  DOCUMENT_YEARS_FETCH_REQUEST_SUCCESS,
  DOCUMENT_YEARS_FETCH_REQUEST_FAILURE,
  DOCUMENT_REVIEW_REQUEST,
  DOCUMENT_REVIEW_REQUEST_SUCCESS,
  DOCUMENT_REVIEW_REQUEST_FAILURE,
  GENERATE_OTP_REQUEST,
  GENERATE_OTP_REQUEST_SUCCESS,
  GENERATE_OTP_REQUEST_FAILURE,
  SINGLE_DOCUMENT_CLEAN_REQUEST,
  VALIDATE_OTP_REQUEST,
  VALIDATE_OTP_REQUEST_SUCCESS,
  VALIDATE_OTP_REQUEST_FAILURE,
  OTP_PROPS_CLEAN_REQUEST,
  DOCUMENT_RENAME_REQUEST,
  DOCUMENT_RENAME_REQUEST_SUCCESS,
  DOCUMENT_RENAME_REQUEST_FAILURE,
  TAX_DOCUMENT_RE_UPLOAD_REQUEST,
  TAX_DOCUMENT_RE_UPLOAD_REQUEST_SUCCESS,
  TAX_DOCUMENT_RE_UPLOAD_REQUEST_FAILURE,
  CLEAN_TAX_DOCUMENT_RE_UPLOAD_PROPS,
  PDF_MERGE_REQUEST,
  PDF_MERGE_REQUEST_SUCCESS,
  PDF_MERGE_REQUEST_FAILURE,
  CLEAN_PDF_MERGE_PROPS,
  CLEAN_DOCUMENT_REVIEW_REQUEST_PROPS,
  POLICY_DISCLAMER_REQUEST,
  POLICY_DISCLAMER_REQUEST_SUCCESS,
  POLICY_DISCLAMER_REQUEST_FAILURE,
  CLEAN_POLICY_DISCLAMER,
  DOCUMENT_SIGNATURE_CLEAN_REQUEST,
  DOCUMENT_SIGNATURE_FETCH_REQUEST,
  DOCUMENT_SIGNATURE_FETCH_REQUEST_SUCCESS,
  DOCUMENT_SIGNATURE_FETCH_REQUEST_FAILURE,
  DOCUMENT_SIGNATURE_UPSERT_REQUEST,
  DOCUMENT_SIGNATURE_UPSERT_REQUEST_SUCCESS,
  DOCUMENT_SIGNATURE_UPSERT_REQUEST_FAILURE,
  DOCUMENT_TRANSFER_REQUEST,
  DOCUMENT_TRANSFER_REQUEST_SUCCESS,
  DOCUMENT_TRANSFER_REQUEST_FAILURE,
  PROFILING_STATUS_CHANGE_REQUEST,
  PROFILING_STATUS_CHANGE_REQUEST_SUCCESS,
  PROFILING_STATUS_CHANGE_REQUEST_FAILURE,
  CLEAN_DOCUMENT_TRANSFER_PROPS,
  DOCUMENT_SELF_REVIEW_REQUEST,
  DOCUMENT_SELF_REVIEW_REQUEST_SUCCESS,
  DOCUMENT_SELF_REVIEW_REQUEST_FAILURE,
  UPSERT_DOCUMENT_SELF_REVIEW_REQUEST,
  UPSERT_DOCUMENT_SELF_REVIEW_REQUEST_SUCCESS,
  UPSERT_DOCUMENT_SELF_REVIEW_REQUEST_FAILURE,
  TAX_RETURN_VISIBILITY_REQUEST,
  TAX_RETURN_VISIBILITY_REQUEST_SUCCESS,
  TAX_RETURN_VISIBILITY_REQUEST_FAILURE,
  UPSERT_TAX_RETURN_VISIBILITY_REQUEST,
  UPSERT_TAX_RETURN_VISIBILITY_REQUEST_SUCCESS,
  UPSERT_TAX_RETURN_VISIBILITY_REQUEST_FAILURE,
  CLEAN_TAX_RETURN_VISIBILITY_PROPS,
  CLEAN_SELF_REVIEW_DOCUMENT_PROPS,
  REUPLOAD_DOCUMENT_REQUEST,
  REUPLOAD_DOCUMENT_REQUEST_SUCCESS,
  REUPLOAD_DOCUMENT_REQUEST_FAILURE,
  MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST,
  MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST_SUCCESS,
  MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST_FAILURE,
  NOTIFY_USER_DURING_DOCUMENT_UPLOAD,
  NOTIFY_USER_DURING_DOCUMENT_UPLOAD_SUCCESS,
  NOTIFY_USER_DURING_DOCUMENT_UPLOAD_FAILURE,
  DOCUMENT_NOTE_ADD_REQUEST,
  DOCUMENT_NOTE_ADD_REQUEST_SUCCESS,
  DOCUMENT_NOTE_ADD_REQUEST_FAILURE,
  DOCUMENT_NOTE_ADD_BY_BULK_REQUEST,
  DOCUMENT_NOTE_ADD_BY_BULK_REQUEST_SUCCESS,
  DOCUMENT_NOTE_ADD_BY_BULK_REQUEST_FAILURE,
  DOCUMENT_NOTES_FETCH_REQUEST,
  DOCUMENT_NOTES_FETCH_REQUEST_SUCCESS,
  DOCUMENT_NOTES_FETCH_REQUEST_FAILURE,
  DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION,
  DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION_SUCCESS,
  DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION_FAILURE,
  DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST,
  DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST_SUCCESS,
  DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST_FAILURE,
  DOCUMENT_DOWNLOAD_BULK_REQUEST,
  DOCUMENT_DOWNLOAD_BULK_REQUEST_SUCCESS,
  DOCUMENT_DOWNLOAD_BULK_REQUEST_FAILURE,
  DOCUMENT_READ_STATUS_REQUEST,
  DOCUMENT_READ_STATUS_REQUEST_SUCCESS,
  DOCUMENT_READ_STATUS_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  yearPayload: [],
  yearLoading: false,
  yearErrors: {},
  otpPayload: [],
  otpErrors: {},
  otpLoading: false,
  validateOtpPayload: [],
  validateOtpErrors: {},
  validateOtpLoading: false,
  renameDocument: [],
  renameDocumentErrors: {},
  renameDocumentLoading: false,
  taxDocumentReUpload: [],
  taxDocumentReUploadLoading: false,
  taxDocumentReUploadErrors: {},
  pdfMerge: [],
  pdfMergeLoading: false,
  pdfMergeErrors: {},
  policyTextLoading: false,
  policyText: [],
  policyTextErrors: {},
  documentSignaturePayload: [],
  documentSignatureLoading: false,
  documentSignatureErrors: {},
  singleDocumentSignaturePayload: [],
  singleDocumentSignatureLoading: false,
  singleDocumentSignatureErrors: {},
  documentTransferLoading: false,
  documentTransferErrors: {},
  profilingStatusChangeLoading: false,
  profilingStatusChangeErrors: {},
  documentSelfReview: [],
  documentSelfReviewLoading: false,
  documentSelfReviewErrors: {},
  upsertDocumentSelfReview: [],
  upsertDocumentSelfReviewLoading: false,
  upsertDocumentSelfReviewErrors: {},
  taxReturnVisibility: [],
  taxReturnVisibilityLoading: false,
  taxReturnVisibilityErrors: {},
  upsertTaxReturnVisibility: [],
  upsertTaxReturnVisibilityLoading: false,
  upsertTaxReturnVisibilityErrors: {},
  reUploadDocument: [],
  reUploadDocumentLoading: false,
  reUploadDocumentErrors: {},
  maxDocumentUploadLimitRequest: [],
  maxDocumentUploadRequestLimitLoading: false,
  maxDocumentUploadRequestLimitErrors: {},
  notifyOnDocUpload: [],
  notifyOnDocUploadLoading: false,
  notifyOnDocUploadErrors: {},
  documentNoteAdd: [],
  documentNoteAddLoading: false,
  documentNoteAddErrors: {},
  documentNoteAddByBulk: [],
  documentNoteAddByBulkLoading: false,
  documentNoteAddByBulkErrors: {},
  documentNotes: [],
  documentNotesLoading: false,
  documentNotesErrors: {},
  documentNotesByPaginationPayload: [],
  documentNotesByPaginationLoading: false,
  documentNotesByPaginationErrors: {},
  documentNotesPaginationData: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  documentReferenceIdsByClient: [],
  documentReferenceIdsByClientLoading: false,
  documentReferenceIdsByClientError: {},
  documentDownloadBulk: [],
  documentDownloadBulkLoading: false,
  documentDownloadBulkError: {},
  documentReadStatus: [],
  documentReadStatusLoading: false,
  documentReadStatusError: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const documentReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case DOCUMENTS_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case DOCUMENTS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case DOCUMENTS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case DOCUMENT_ADD_REQUEST:
    case DOCUMENT_REVIEW_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case DOCUMENT_ADD_REQUEST_SUCCESS:
    case DOCUMENT_REVIEW_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: action.data,
        singleErrors: {},
      });

    case DOCUMENT_ADD_REQUEST_FAILURE:
    case DOCUMENT_REVIEW_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });

    case CLEAN_DOCUMENT_REVIEW_REQUEST_PROPS:
      return Object.assign({}, state, {
        singleLoading: false,
        singlePayload: [],
        singleErrors: {},
      });

    case DOCUMENT_YEARS_FETCH_REQUEST:
      return Object.assign({}, state, {
        yearLoading: true,
      });

    case DOCUMENT_YEARS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        yearLoading: false,
        yearPayload: action.data,
        singleErrors: {},
      });

    case DOCUMENT_YEARS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        yearLoading: false,
        yearErrors: action.error,
      });

    case DOCUMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
        yearPayload: [],
        yearLoading: false,
        yearErrors: {},
      });

    case GENERATE_OTP_REQUEST:
      return Object.assign({}, state, {
        otpLoading: true,
      });

    case GENERATE_OTP_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        otpLoading: false,
        otpPayload: action.data,
        otpErrors: {},
      });

    case GENERATE_OTP_REQUEST_FAILURE:
      return Object.assign({}, state, {
        otpLoading: false,
        otpErrors: action.error,
      });

    case POLICY_DISCLAMER_REQUEST:
      return Object.assign({}, state, {
        policyTextLoading: true,
      });

    case POLICY_DISCLAMER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        policyTextLoading: false,
        policyText: action.data,
        policyTextErrors: {},
      });

    case POLICY_DISCLAMER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        policyTextLoading: false,
        policyTextErrors: action.error,
      });

    case VALIDATE_OTP_REQUEST:
      return Object.assign({}, state, {
        validateOtpLoading: true,
      });

    case VALIDATE_OTP_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        validateOtpLoading: false,
        validateOtpPayload: action.data,
        validateOtpErrors: {},
      });

    case VALIDATE_OTP_REQUEST_FAILURE:
      return Object.assign({}, state, {
        validateOtpLoading: false,
        validateOtpErrors: action.error,
      });

    case SINGLE_DOCUMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singlePayload: [],
        singleLoading: false,
        singleErrors: {},
      });

    case OTP_PROPS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        otpErrors: {},
        otpLoading: false,
        validateOtpErrors: {},
        validateOtpLoading: false,
      });

    case CLEAN_POLICY_DISCLAMER:
      return Object.assign({}, state, {
        policyTextLoading: false,
        policyText: [],
        policyTextErrors: {},
      });

    case DOCUMENT_RENAME_REQUEST:
      return Object.assign({}, state, {
        renameDocumentLoading: true,
      });

    case DOCUMENT_RENAME_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        renameDocumentLoading: false,
        renameDocument: action.data,
        renameDocumentErrors: {},
      });

    case DOCUMENT_RENAME_REQUEST_FAILURE:
      return Object.assign({}, state, {
        renameDocumentLoading: false,
        renameDocumentErrors: action.error,
      });

    case TAX_DOCUMENT_RE_UPLOAD_REQUEST:
      return Object.assign({}, state, {
        taxDocumentReUploadLoading: true,
      });

    case TAX_DOCUMENT_RE_UPLOAD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxDocumentReUploadLoading: false,
        taxDocumentReUpload: action.data,
        taxDocumentReUploadErrors: {},
      });

    case TAX_DOCUMENT_RE_UPLOAD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxDocumentReUploadLoading: false,
        taxDocumentReUploadErrors: action.error,
      });

    case PDF_MERGE_REQUEST:
      return Object.assign({}, state, {
        pdfMergeLoading: true,
      });

    case PDF_MERGE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        pdfMergeLoading: false,
        pdfMerge: action.data,
        pdfMergeErrors: {},
      });

    case PDF_MERGE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        pdfMergeLoading: false,
        pdfMergeErrors: action.error,
      });

    case CLEAN_PDF_MERGE_PROPS:
      return Object.assign({}, state, {
        pdfMergeLoading: false,
        pdfMerge: [],
        pdfMergeErrors: {},
      });
    case CLEAN_TAX_DOCUMENT_RE_UPLOAD_PROPS:
      return Object.assign({}, state, {
        taxDocumentReUploadLoading: false,
        taxDocumentReUpload: [],
        taxDocumentReUploadErrors: {},
      });

    case DOCUMENT_SIGNATURE_FETCH_REQUEST:
      return Object.assign({}, state, {
        documentSignatureLoading: true,
      });

    case DOCUMENT_SIGNATURE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentSignatureLoading: false,
        documentSignaturePayload: action.data,
        documentSignatureErrors: {},
      });

    case DOCUMENT_SIGNATURE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentSignatureLoading: false,
        documentSignatureErrors: action.error,
      });

    case DOCUMENT_SIGNATURE_UPSERT_REQUEST:
      return Object.assign({}, state, {
        singleDocumentSignatureLoading: true,
      });

    case DOCUMENT_SIGNATURE_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleDocumentSignatureLoading: false,
        documentSignaturePayload: action.data,
        singleDocumentSignatureErrors: {},
      });

    case DOCUMENT_SIGNATURE_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleDocumentSignatureLoading: false,
        singleDocumentSignatureErrors: action.error,
      });

    case DOCUMENT_SIGNATURE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        documentSignaturePayload: [],
        documentSignatureLoading: false,
        documentSignatureErrors: {},
        singleDocumentSignaturePayload: [],
        singleDocumentSignatureLoading: false,
        singleDocumentSignatureErrors: {},
      });

    case DOCUMENT_TRANSFER_REQUEST:
      return Object.assign({}, state, {
        documentTransferLoading: true,
      });

    case DOCUMENT_TRANSFER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentTransferLoading: false,
        documentTransferErrors: {},
      });

    case DOCUMENT_TRANSFER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentTransferLoading: false,
        documentTransferErrors: action.error,
      });

    case PROFILING_STATUS_CHANGE_REQUEST:
      return Object.assign({}, state, {
        profilingStatusChangeLoading: true,
      });

    case PROFILING_STATUS_CHANGE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        profilingStatusChangeLoading: false,
        profilingStatusChangeErrors: {},
      });

    case PROFILING_STATUS_CHANGE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        profilingStatusChangeLoading: false,
        profilingStatusChangeErrors: action.error,
      });

    case DOCUMENT_SELF_REVIEW_REQUEST:
      return Object.assign({}, state, {
        documentSelfReviewLoading: true,
      });

    case DOCUMENT_SELF_REVIEW_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentSelfReviewLoading: false,
        documentSelfReview: action.data,
        documentSelfReviewErrors: {},
      });

    case DOCUMENT_SELF_REVIEW_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentSelfReviewLoading: false,
        documentSelfReviewErrors: action.error,
      });

    case UPSERT_DOCUMENT_SELF_REVIEW_REQUEST:
      return Object.assign({}, state, {
        upsertDocumentSelfReviewLoading: true,
      });

    case UPSERT_DOCUMENT_SELF_REVIEW_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        upsertDocumentSelfReviewLoading: false,
        upsertDocumentSelfReview: action.data,
        upsertDocumentSelfReviewErrors: {},
      });

    case UPSERT_DOCUMENT_SELF_REVIEW_REQUEST_FAILURE:
      return Object.assign({}, state, {
        upsertDocumentSelfReviewLoading: false,
        upsertDocumentSelfReviewErrors: action.error,
      });

    case TAX_RETURN_VISIBILITY_REQUEST:
      return Object.assign({}, state, {
        taxReturnVisibilityLoading: true,
      });

    case TAX_RETURN_VISIBILITY_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taxReturnVisibilityLoading: false,
        taxReturnVisibility: action.data,
        taxReturnVisibilityErrors: {},
      });

    case TAX_RETURN_VISIBILITY_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taxReturnVisibilityLoading: false,
        taxReturnVisibilityErrors: action.error,
      });

    case UPSERT_TAX_RETURN_VISIBILITY_REQUEST:
      return Object.assign({}, state, {
        upsertTaxReturnVisibilityLoading: true,
      });

    case UPSERT_TAX_RETURN_VISIBILITY_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        upsertTaxReturnVisibilityLoading: false,
        upsertTaxReturnVisibility: action.data,
        upsertTaxReturnVisibilityErrors: {},
      });

    case UPSERT_TAX_RETURN_VISIBILITY_REQUEST_FAILURE:
      return Object.assign({}, state, {
        upsertTaxReturnVisibilityLoading: false,
        upsertTaxReturnVisibilityErrors: action.error,
      });

    case CLEAN_DOCUMENT_TRANSFER_PROPS:
      return Object.assign({}, state, {
        documentTransferLoading: false,
        documentTransferErrors: {},
      });

    case CLEAN_SELF_REVIEW_DOCUMENT_PROPS:
      return Object.assign({}, state, {
        documentSelfReview: [],
        documentSelfReviewLoading: false,
        documentSelfReviewErrors: {},
        upsertDocumentSelfReview: [],
        upsertDocumentSelfReviewLoading: false,
        upsertDocumentSelfReviewErrors: {},
      });

    case CLEAN_TAX_RETURN_VISIBILITY_PROPS:
      return Object.assign({}, state, {
        taxReturnVisibility: [],
        taxReturnVisibilityLoading: false,
        taxReturnVisibilityErrors: {},
        upsertTaxReturnVisibility: [],
        upsertTaxReturnVisibilityLoading: false,
        upsertTaxReturnVisibilityErrors: {},
      });

    case REUPLOAD_DOCUMENT_REQUEST:
      return Object.assign({}, state, {
        reUploadDocumentLoading: true,
      });

    case REUPLOAD_DOCUMENT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        reUploadDocumentLoading: false,
        reUploadDocument: action.data,
        reUploadDocumentErrors: {},
      });

    case REUPLOAD_DOCUMENT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        reUploadDocumentLoading: false,
        reUploadDocumentErrors: action.error,
      });

    case MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST:
      return Object.assign({}, state, {
        maxDocumentUploadRequestLimitLoading: true,
      });

    case MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        maxDocumentUploadRequestLimitLoading: false,
        maxDocumentUploadLimitRequest: action.data,
        maxDocumentUploadRequestLimitErrors: {},
      });

    case MAX_DOCUMENT_UPLOAD_LIMIT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        maxDocumentUploadRequestLimitLoading: false,
        maxDocumentUploadRequestLimitErrors: action.error,
      });

    case NOTIFY_USER_DURING_DOCUMENT_UPLOAD:
      return Object.assign({}, state, {
        notifyOnDocUploadLoading: true,
      });

    case NOTIFY_USER_DURING_DOCUMENT_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        notifyOnDocUploadLoading: false,
        notifyOnDocUpload: action.data,
        notifyOnDocUploadErrors: {},
      });

    case NOTIFY_USER_DURING_DOCUMENT_UPLOAD_FAILURE:
      return Object.assign({}, state, {
        notifyOnDocUploadLoading: false,
        notifyOnDocUploadErrors: action.error,
      });

    case DOCUMENT_NOTE_ADD_REQUEST:
      return Object.assign({}, state, {
        documentNoteAddLoading: true,
      });

    case DOCUMENT_NOTE_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentNoteAddLoading: false,
        documentNoteAdd: action.data,
        documentNoteAddErrors: {},
      });

    case DOCUMENT_NOTE_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentNoteAddLoading: false,
        documentNoteAddErrors: action.error,
      });

    case DOCUMENT_NOTE_ADD_BY_BULK_REQUEST:
      return Object.assign({}, state, {
        documentNoteAddByBulkLoading: true,
      });

    case DOCUMENT_NOTE_ADD_BY_BULK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentNoteAddByBulkLoading: false,
        documentNoteAddByBulk: action.data,
        documentNoteAddByBulkErrors: {},
      });

    case DOCUMENT_NOTE_ADD_BY_BULK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentNoteAddByBulkLoading: false,
        documentNoteAddByBulkErrors: action.error,
      });

    case DOCUMENT_NOTES_FETCH_REQUEST:
      return Object.assign({}, state, {
        documentNotesLoading: true,
      });

    case DOCUMENT_NOTES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentNotesLoading: false,
        documentNotes: action.data,
        documentNotesErrors: {},
      });

    case DOCUMENT_NOTES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentNotesLoading: false,
        documentNotesErrors: action.error,
      });

    case DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION:
      return Object.assign({}, state, {
        documentNotesByPaginationLoading: true,
      });

    case DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION_SUCCESS:
      return Object.assign({}, state, {
        documentNotesByPaginationPayload: action.data,
        documentNotesByPaginationLoading: false,
        documentNotesByPaginationErrors: {},
        documentNotesPaginationData: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
          showSizeChanger: true,
        },
      });
    case DOCUMENT_NOTES_FETCH_REQUEST_BY_PAGINATION_FAILURE:
      return Object.assign({}, state, {
        documentNotesByPaginationLoading: false,
        documentNotesByPaginationErrors: action.error,
      });

    case DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        documentReferenceIdsByClientLoading: true,
      });

    case DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentReferenceIdsByClientLoading: false,
        documentReferenceIdsByClient: action.data,
        documentReferenceIdsByClientError: {},
      });

    case DOCUMENT_REFERENCE_ID_BY_CLIENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentReferenceIdsByClientLoading: false,
        documentReferenceIdsByClientError: action.error,
      });

    case DOCUMENT_DOWNLOAD_BULK_REQUEST:
      return Object.assign({}, state, {
        documentDownloadBulkLoading: true,
      });

    case DOCUMENT_DOWNLOAD_BULK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentDownloadBulkLoading: false,
        documentDownloadBulk: action.data,
        documentDownloadBulkError: {},
      });

    case DOCUMENT_DOWNLOAD_BULK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentDownloadBulkLoading: false,
        documentDownloadBulkError: action.error,
      });

    case DOCUMENT_READ_STATUS_REQUEST:
      return Object.assign({}, state, {
        documentReadStatusLoading: true,
      });

    case DOCUMENT_READ_STATUS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        documentReadStatusLoading: false,
        documentReadStatus: action.data,
        documentReadStatusError: {},
      });

    case DOCUMENT_READ_STATUS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        documentReadStatusLoading: false,
        documentReadStatusError: action.error,
      });

    default:
      return state;
  }
};

export default documentReducer;
